/**
 * @Date:   2018-02-11T10:41:46+08:00
 * @Last modified time: 2018-02-28T18:53:33+08:00
 */

import { DailyReport } from '../constants/daily-report-constants.js';
import dailyReportService from '../services/DailyReport/daily-report-service';
import otherReportService from '../services/DailyReport/other-report-service.js';
import userGroupService from '../services/DailyReport/user-group-service.js';
import userGroupDetailService from '../services/DailyReport/user-group-detail-service';
 // import remindWeeklyReportReview from '../services/DailyReport/weekly-report-review-service';
import _util from '../utils/index.js';
import { push } from 'react-router-redux';
import { message } from 'antd';
import moment from 'moment';

// daily reports
export function initDailyReport(gets) {
	return dispatch => {
		dailyReportService.initDailyReport(gets, res => {
			let template = JSON.parse(res.data.template);
			template.forEach(item => {
				switch (item.type) {
					case 'column':
						item.height = 80 * Math.ceil(item.children.length/4) + "px";
						break;
					case 'columns':
						item.height = Math.ceil(item.children.length) * 40 + "px";
						break;
					default :
						item.height = Math.ceil(item.children.length) * 40 + "px";
				}
			});
			// console.log(template);
			dispatch({
				type: DailyReport.ActionTypes.INITDAILYREPORTSUCCESS,
				payload: {
					currentID: false,
					initDailyReportStatus: true,
					dailyReportEmployee: res.data.employee,
					dailyReportTypeID: res.data.type_id,
					dailyReportTemplate: template
				}
			})
		}, err => {})
	}
}
export function editDailyReport(data) {
	return dispatch => {
		dispatch({
			type: DailyReport.ActionTypes.EDITDAILYREPORTSUCCESS,
			payload: {
				data: data
			}
		})
	}
}
export function saveDailyReport(posts, callback) {
	return dispatch => {
		dailyReportService.saveDailyReport(posts, res => {
			if ('function' === typeof callback) {
				callback(res.data.Success);
			}
		}, err => {})
	}
}
export function fetchDailyReportList(gets) {
	return dispatch => {
		dailyReportService.fetchDailyReportList(gets, res => {
			// console.log(res);
			let listData = res.data.list_data.Data;
			listData.forEach(data => {
				switch(data.status) {
					case 0:
						data.status_name = "未提交";
						break;
					case 1:
						data.status_name = "未回复";
						break;
					case 2:
						data.status_name = "已回复";
						break;
					default :
						data.status_name = "已回复";
				}
				// data.reply_time = data.reply_time ? moment(data.reply_time).format('YYYY-MM-DD') : null;
				// console.log(data);
			});
			dispatch({
				type: DailyReport.ActionTypes.FETCHDAILYREPORTSUCCESS,
				payload: {
					fetchDailyReportListStatus: true,
					dailyReportList: listData,
					dailyReportIsHr: res.data.is_hr,
					dailyReportIsLeader: res.data.is_leader,
					dailyReportPage: res.data.list_data.Page,
					dailyReportTotal: res.data.list_data.Total
				}
			});
		}, err => {})
	}
}
export function updateDailyReport(puts, callback) {
	return dispatch => {
		dailyReportService.updateDailyReport(puts, res => {
			if ('function' === typeof callback) {
				callback(res.data.Success);
			}
		}, err => {})
	}
}
export function fetchDailyReportDetail(gets, callback) {
	return dispatch => {
		dailyReportService.fetchDailyReportDetail(gets, res => {
			// console.log(res);
			let template = JSON.parse(res.data.work_report.table_content);
			template.forEach(item => {
				switch (item.type) {
					case 'column':
						item.height = 80 * Math.ceil(item.children.length/4) + "px";
						break;
					case 'columns':
						item.height = Math.ceil(item.children.length) * 40 + "px";
						break;
					default :
						item.height = Math.ceil(item.children.length) * 40 + "px";
				}
			});
			// console.log(template);
			dispatch({
				type: DailyReport.ActionTypes.INITDAILYREPORTSUCCESS,
				payload: {
					prevID: res.data.prev_id,
					nextID: res.data.next_id,
					currentID: gets.modelId,
					initDailyReportStatus: true,
					dailyReportEmployee: res.data.employee,
					dailyReportTypeID: res.data.work_report.type_id,
					dailyReportTemplate: template,
					dailyReportReply: res.data.replies
				}
			})
			if ('function' === typeof callback) {
				callback(true);
			}
		}, err => {})
	}
}
export function multiDeleteDailyReport(deletes, callback) {
	return dispatch => {
		dailyReportService.multiDeleteDailyReport(deletes, res => {
			// console.log(res);
			if ('function' === typeof callback) {
				callback(res.data.Success);
			}
		}, err => {})
	}
}
export function submitDailyReport(puts, callback) {
	return dispatch => {
		dailyReportService.submitDailyReport(puts, res => {
			// console.log(res);
			if ('function' === typeof callback) {
				callback(res.data.Success);
			}
		}, err => {})
	}
}
export function fetchLeaderDailyReportList(params) {
	return dispatch => {
		dailyReportService.fetchLeaderDailyReportList(params, res => {
			let listData = res.data.list_data.Data;
			listData.forEach(data => {
				switch(data.status) {
					case 0:
						data.status_name = "未提交";
						break;
					case 1:
						data.status_name = "未回复";
						break;
					case 2:
						data.status_name = "已回复";
						break;
					default :
						data.status_name = "已回复";
				}
			});
			// console.log(listData, res);
			dispatch({
				type: DailyReport.ActionTypes.FETCHLEADERDAILYREPORTSUCCESS,
				payload: {
					leaderDailyReportList: listData,
					leaderDailyReportIsHr: res.data.is_hr,
					leaderDailyReportIsLeader: res.data.is_leader,
					leaderDailyReportPage: res.data.list_data.Page,
					leaderDailyReportTotal: res.data.list_data.Total
				}
			})
		}, err => {})
	}
}
export function fetchHrDailyReportList(params) {
	return dispatch => {
		dailyReportService.fetchHrDailyReportList(params, res => {
			let listData = res.data.list_data.Data;
			listData.forEach(data => {
				switch(data.status) {
					case 0:
						data.status_name = "未提交";
						break;
					case 1:
						data.status_name = "未回复";
						break;
					case 2:
						data.status_name = "已回复";
						break;
					default :
						data.status_name = "已回复";
				}
			});
			// console.log(listData, res);
			dispatch({
				type: DailyReport.ActionTypes.FETCHLEADERDAILYREPORTSUCCESS,
				payload: {
					leaderDailyReportList: listData,
					leaderDailyReportIsHr: res.data.is_hr,
					leaderDailyReportIsLeader: res.data.is_leader,
					leaderDailyReportPage: res.data.list_data.Page,
					leaderDailyReportTotal: res.data.list_data.Total
				}
			})
		}, err => {})
	}
}

export function replyDailyReport(posts, callback) {
	return dispatch => {
		dailyReportService.replyDailyReport(posts, res => {
			if ('function' === typeof callback) {
				callback(res.data.Success);
			}
		}, err => {})
	}
}

// other report
export function fetchReportsList (params) {
    return dispatch => {
        otherReportService.fetchReportsList(params, (res) => {
			if (res.data.Errors) {
				throw new Error(res.data.Errors[0])
			}
            if (res.data) {
            	let listData = res.data
            	// console.log(listData)
	            listData.list_data.Data.forEach(data => {
	               data.created_time = moment(data.created_time).format('YYYY-MM-DD HH:mm:ss')
	            })
                dispatch({
                    type: DailyReport.ActionTypes.FETCHREPORTSUCCESS,
                    payload: {
                        reportsInfo: listData,
						actionStatus: false
                    }
                })
            }
        }, (err) => {
            dispatch({
                type: DailyReport.ActionTypes.FETCHREPORTFAILURE,
				payload: {
					err
				}
            })
        })
    }
}

// export function fetchWeeklyReportsList (params) {
//     return dispatch => {
//         otherReportService.fetchWeeklyReportsList(params, (res) => {
// 			if (res.data.Errors) {
// 				throw new Error(res.data.Errors[0])
// 			}
//             if (res.data) {
//             	let listData = res.data
//             	// console.log(listData)
// 	            listData.list_data.Data.forEach(data => {
// 	               data.created_time = moment(data.created_time).format('YYYY-MM-DD HH:mm:ss')
// 	            })
//                 dispatch({
//                     type: DailyReport.ActionTypes.FETCHREPORTSUCCESS,
//                     payload: {
//                         reportsInfo: listData,
// 						actionStatus: false
//                     }
//                 })
//             }
//         }, (err) => {
//             dispatch({
//                 type: DailyReport.ActionTypes.FETCHREPORTFAILURE,
// 				payload: {
// 					err
// 				}
//             })
//         })
//     }
// }

export function fetchWorkReportInit (params) {
    return dispatch => {
        otherReportService.fetchWorkReportInit(params, (res) => {
			if (res.data.Errors) {
				throw new Error(res.data.Errors[0])
			}
            if (res.data) {
                dispatch({
                    type: DailyReport.ActionTypes.FETCHREPORTINITSUCCESS,
                    payload: {
                        reportInit: res.data
                    }
                })
            }
        }, (err) => {
            dispatch({
                type: DailyReport.ActionTypes.FETCHREPORTINITFAILURE,
				payload: {
					err
				}
            })
        })
    }
}

export function createWorkReport (data) {
    return dispatch => {
        otherReportService.createWorkReport(data, (res) => {
            if (res.data.Success) {
                dispatch({
                    type: DailyReport.ActionTypes.CREATEREPORTESUCCESS,
					payload: {
						actionStatus: true
					}
                })
				message.success('操作成功')
            }
        }, (err) => {
            dispatch({
                type: DailyReport.ActionTypes.CREATEREPORTEFAILURE,
            })
        })
    }
}

export function saveWorkReport (data) {
    return dispatch => {
        otherReportService.saveWorkReport(data, (res) => {
            if (res.data.Success) {
                dispatch({
                    type: DailyReport.ActionTypes.CREATEREPORTESUCCESS,
                })
				message.success('操作成功')
            }
        }, (err) => {
            dispatch({
                type: DailyReport.ActionTypes.CREATEREPORTEFAILURE,
            })
        })
    }
}

export function fetchReportDetail (id) {
	return dispatch => {
		otherReportService.fetchReportDetail(id, (res) => {
			if (res.data) {
				// console.log(res.data.work_report)
				res.data.work_report.created_time = moment(res.data.work_report.created_time).format('YYYY-MM-DD HH:mm:ss')
				dispatch({
					type: DailyReport.ActionTypes.FETCHREPORTDETAILSUCCESS,
					payload: {
						reportDetail: res.data
					}
				})
			}
		}, (err) => {
			dispatch({
				type: DailyReport.ActionTypes.FETCHREPORTDETAILFAILURE
			})
		})
	}
}

export function emptyReportDetail () {
	return dispatch => {
		dispatch({
			type: DailyReport.ActionTypes.EMPTY,
			payload: {
				reportDetail: null
			}
		})
	}
}

export function multiDeleteReports (data) {
	return dispatch => {
		otherReportService.multiDeleteReports(data, (res) => {
			if (res.data.Success) {
				_util.successTips('删除成功')
				dispatch({
					type: DailyReport.ActionTypes.DELETEREPORTSSUCCESS,
					payload: {
						actionStatus: true
					}
				})
			} else {
				if (res.data.Errors) {
					throw new Error(res.data.Errors[0])
				}
			}
		}, (err) => {
			dispatch({
				type: DailyReport.ActionTypes.DELETEREPORTSFAILURE,
				payload: {
					errmsg: err
				}
			})
		})
	}
}


// 设置群组 相关
export function fetchUserGroupList (params) {
	return dispatch => {
		userGroupService.fetchUserGroupList(params, (res) => {
			if (res.data) {
				dispatch({
					type: DailyReport.ActionTypes.FETCHUSERGROUPSUCCESS,
					payload: {
						userGroupList: res.data,
						actionStatus: false
					}
				})
			}
		}, (err) => {
			dispatch({
				type: DailyReport.ActionTypes.FETCHUSERGROUPFAILURE,
				payload: {
					err,
					actionStatus: false
				}
			})
		})
	}
}
export function createUserGroupList (params) {
	return dispatch => {
		userGroupService.createUserGroupList(params, (res) => {
			if (res.data.Success) {
				dispatch({
					type: DailyReport.ActionTypes.CREATEUSERGROUPSUCCESS,
					payload: {
						// userGroupList: res.data
						actionStatus: true
					}
				})
				_util.successTips('创建群组成功')
			}
		}, (err) => {
			dispatch({
				type: DailyReport.ActionTypes.CREATEUSERGROUPFAILURE,
				payload: {
					err,
					actionStatus: false
				}
			})
		})
	}
}
export function deleteUserGroupList (data) {
	return dispatch => {
		userGroupService.deleteUserGroupList(data, (res) => {
			if (res.data.Success) {
				dispatch({
					type: DailyReport.ActionTypes.DELETEUSERGROUPSUCCESS,
					payload: {
						userGroupList: res.data,
						actionStatus: true
					}
				})
			} else {
				if (res.data.Errors) {
					throw new Error(res.data.Error[0])
				}
			}
		}, (err) => {
			dispatch({
				type: DailyReport.ActionTypes.DELETEUSERGROUPFAILURE,
				payload: {
					errmsg: err
				}
			})
		})
	}
}
export function updateUserGroupList (data) {
	return dispatch => {
		userGroupService.updateUserGroupList(data, (res) => {
			if (res.data.Success) {
				dispatch({
					type: DailyReport.ActionTypes.UPDATEUSERGROUPSUCCESS,
					payload: {
						// userGroupList: res.data,
						actionStatus: true
					}
				})
				_util.successTips("修改群组成功")
			} else {
				if (res.data.Errors) {
					throw new Error(res.data.Error[0])
				}
			}
		}, (err) => {
			dispatch({
				type: DailyReport.ActionTypes.UPDATEUSERGROUPFAILURE,
				payload: {
					errmsg: err
				}
			})
		})
	}
}
export function fetchUserGroupDetail (params) {
	return dispatch => {
		userGroupService.fetchUserGroupDetail(params, (res) => {
			if (res.data) {
				dispatch({
					type: DailyReport.ActionTypes.FETCHEUSERGROUPDETAILSUCCESS,
					payload: {
						groupListDetail: res.data
					}
				})
			}
		}, (err) => {
			dispatch({
				type: DailyReport.ActionTypes.FETCHEUSERGROUPDETAILFAILURE,
				payload: {
					err
				}
			})
		})
	}
}
export function emptyUserGroupDetail (params) {
	return dispatch => {
		dispatch({
			type: DailyReport.ActionTypes.EMPTYUSERGROUPDETAIL,
			payload: {
				groupListDetail: null
			}
		})
	}
}
// 通用
export function linkToNewRouter (url) {
	return dispatch => {
		dispatch(push(url))
	}
}

export function fetchCurrentUserDetail (params) {
	return dispatch => {
		otherReportService.fetchCurrentUserDetail(params, (res) => {
			// console.log(res)
			if (res.data) {
				dispatch({
					type: DailyReport.ActionTypes.FETCHCURRENTUSERDETAILSUCCESS,
					payload: {
						currentUserDetail: res.data
					}
				})
			}
		}, (err) => {
			dispatch({
				type: DailyReport.ActionTypes.FETCHCURRENTUSERDETAILFAILURE
			})
		})
	}
}

//userGroupDetail修改特殊查看人
export function fetchUserGroupDetailList(gets) {
 return dispatch => {
  let department_id ={department_id:gets}
  // console.log(department_id);
  userGroupDetailService.fetchUserGroupDetailList(department_id, res => {
   // console.log(res.data.Object.Data);
   // console.log(gets);
   dispatch({
    type: DailyReport.ActionTypes.FETCHUSERGROUPDETAILLISTSUCCESS,
    payload: {
     userGroupData: res.data.Object.Data,
	 userGroupPage: res.data.Object.Page,
	 userGroupPageSize: res.data.Object.PageSize,
     userGroupTotalPage:res.data.Object.Total,
     userGroupDataStatus: "loaded"
    }
   });
  }, err => {});
 }
}

export function updateUserGroupDetailList(puts, index, callback) {
	return dispatch => userGroupDetailService.updateUserGroupDetailList(puts, res => {
		dispatch({
			type: DailyReport.ActionTypes.UPDATEUSERGROUPDETAILLISTSUCCESS,
			payload: {
				index: index,
				value: puts
			}
		});
        if ('function' === typeof callback) {
            callback(res.data.Success);
        }
	}, err => {})
}
export function deleteUserGroupDetailList(deletes, callback) {
    return dispatch => {
        userGroupDetailService.deleteUserGroupDetailList(deletes, res => {
            if (res.data.Success && 'function' === typeof callback) {
                callback(true);
            }
        }, err => {})
    }
}



// WEBPACK FOOTER //
// ./src/actions/daily-report-actions.js